
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import type { ExplainMessages, ExplainTableData } from '../../models'

import { ExplainTotalTypeEnum } from '@empathybroker/tsclient-play/dist/enums/search/debug/result/score-criteria-detail-type.enum'

import { defineComponent } from 'vue'

import { ColorEnum } from '../../enums/color.enum'

import { SteppedAnimationMixin } from '../../mixins'

import { ExplainUtils } from '../../utils'
import ExplainResultsHeaderRow from './explain-results-header-row.component.vue'
import ExplainResultsScoreRow from './explain-results-score-row.component.vue'
import ExplainResultsTiebreakersRow from './explain-results-tiebreakers-row.component.vue'

export default defineComponent({
  name: 'ExplainResultsTable',
  components: {
    ExplainResultsHeaderRow,
    ExplainResultsScoreRow,
    ExplainResultsTiebreakersRow,
  },
  mixins: [SteppedAnimationMixin],
  props: {
    results: {
      type: Array as PropType<Array<Result>>,
      required: true,
    },
    query: {
      type: String as PropType<string>,
      required: true,
    },
    initialAnimationDurationInMillis: {
      type: Number,
      default: 0,
    },
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
    showHeader: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      animationStepDurationsInMillis: [this.initialAnimationDurationInMillis],
      playAnimationOnce: true,
      ColorEnum,
    }
  },
  computed: {
    totals(): ExplainTableData {
      const buildTotalResult = (result: Result): number | string => {
        return ExplainUtils.getScoreCriteriaValue(result).toLocaleString(this.$epb.locale)
      }

      return {
        fieldName: ExplainTotalTypeEnum.TOTAL,
        ids: this.results.map(result => result.id),
        values: this.results.map(buildTotalResult),
        backgroundColor: ColorEnum.BLACK,
      }
    },
    rowData(): Array<ExplainTableData> {
      return ExplainUtils.translateResultsToRowData(this.results, this.messages.tableRows)
    },
  },
  methods: {
    getRowTransitionDelay(rowIndex: number): string {
      if (!!this.initialAnimationDurationInMillis && !this.alreadyPlayedAnimation) {
        const rowAnimationDurationInMillis =
          this.initialAnimationDurationInMillis / (this.rowData.length + 2)
        return `${rowAnimationDurationInMillis * rowIndex}ms`
      }
    },
  },
})
